import { useState, useEffect, useContext } from "react";

import LoadingContext from "../../context/Loading/Loading";

import { SideSheetProvider } from "../../providers/SideSheetProvider/SideSheetProvider";

import { ticketExchangeSeatMap } from "../../utilities/api";

import Modal from "react-bootstrap/Modal";

import EventSelector from "./EventSelector";
import ExchangeTicketsSeatMapWrapper from "./ExchangeTicketsSeatMapWrapper/ExchangeTicketsSeatMapWrapper";

export default function ExchangeModal({
  selectedEvent,
  fromOrder,
  fromTickets,
  fromEvent,
}) {
  const [toEvent, setToEvent] = useState();

  useEffect(() => {
    if (selectedEvent) getSeatMap();
  }, [selectedEvent]);

  const getSeatMap = () => {
    ticketExchangeSeatMap({ eventUUID: selectedEvent })
      .then((res) => {
        setToEvent(res.data);
      })
      .catch((err) => {
        console.error(err);
      });
  };

  return (
    <>
      {/* <Modal.Header closeButton>
          <Modal.Title>Exchange Tickets</Modal.Title>
        </Modal.Header> */}
      <Modal.Body className="p-0">
        {/* <EventSelector events={events} setEvent={setEvent} /> */}
        {selectedEvent && (
          <SideSheetProvider>
            <ExchangeTicketsSeatMapWrapper
              eventId={toEvent?.uuid}
              fromOrder={fromOrder}
              fromEvent={fromEvent}
              fromTickets={fromTickets}
            />
          </SideSheetProvider>
        )}
      </Modal.Body>
    </>
  );
}
